import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ModalConfirmationComponent } from 'app/shared/components/modal-confirmation/modal-confirmation.component';
import { BzgModalService } from 'bz-genome-angular';
import { AuthenticationListUtils } from '../utils/authentication-list.utils';
import { AuthenticationTypes } from 'app/security/core/enums/authentication-types.enum';

@Component({
  selector: 'multiple-auth-list',
  templateUrl: './multiple-auth-list.component.html',
  styleUrls: ['./multiple-auth-list.component.scss']
})
export class MultipleAuthListComponent implements OnChanges {
  deleteActivated: Boolean = false;
  searchValue: any;
  filteredAuthenticatorList: any[] = [];
  selectedItemsForDeletion: string[] = [];
  items: any;

  @Input() authenticatorList: any[] = [];
  @Input() isDisabled: boolean = false;
  @Input() selectedMultipleAuthenticator: any;
  @Input() selectedMetadata: any;
  @Input() selectItemInput: any;

  @Output() createMultipleAuthenticator = new EventEmitter();
  @Output() selectedAuthenticator = new EventEmitter<any>();
  @Output() unSelectedAuthenticator = new EventEmitter<any>();
  @Output() selectedItem = new EventEmitter<any>();
  @Output() deleteAuthenticators = new EventEmitter<any>();

  constructor(private _modalService: BzgModalService, private _authListUtils: AuthenticationListUtils) { }

  ngOnInit(): void {
    this.filteredAuthenticatorList = [...this.authenticatorList].sort((a, b) => 
      a.displayName.localeCompare(b.displayName)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['authenticatorList'] && changes['authenticatorList'].currentValue) {
      this.filterAuthenticators();
    }
    if (this.selectedMultipleAuthenticator) {
      this.onSelectAuthenticator(this.selectedMultipleAuthenticator);
    }
  }

  addAuthenticator() {
    this.createMultipleAuthenticator.emit(true);
  }

  onDeleteOption() {
    this.deleteActivated = true;
    this.selectedItemsForDeletion = []; // Clear previous selections
    // Clear all selected flags
    this.filteredAuthenticatorList.forEach(auth => auth.selected = false);
    this.authenticatorList.forEach(auth => auth.selected = false);
  }

  onCancelDelete() {
    this.deleteActivated = false;
    this.selectedItemsForDeletion = []; // Clear the selection list
    // Clear all selected flags
    this.filteredAuthenticatorList.forEach(auth => auth.selected = false);
    this.authenticatorList.forEach(auth => auth.selected = false);
  }

  onShowConfirmation() {
    if (this.selectedItemsForDeletion.length > 0) {
      this.showDeleteModal(this.selectedItemsForDeletion);
    }
  }

  onBackToList() {
    this.unSelectedAuthenticator.emit(null);
  }

  onShowInfoAuthenticator() {
    this.selectedItem.emit(null);
  }

  onSelectAuthenticator(auth: any) {
    let options = [];
    let items = [];

    if (auth.type === AuthenticationTypes.OAUTH2) {
      const oauthOptions = this.authenticatorList.find(item => item.displayName === auth.displayName).oauthOptions;
      items = oauthOptions.flows.find(flow => flow.name === auth.oauthOptions.activeFlow).properties;
    } else {
      options = this.authenticatorList.find(item => item.displayName === auth.displayName).options;
      items = Object.entries(options).map(([key, value]) => ({ key, value }));
    }
    
    this.items = this._authListUtils.sortItems(items);

    const removeElements = ['encryptionCertificateName', 'signatureCertificateName', 'customAuthenticationName'];
    // Remove objects from items that have any of the keys in removeElements
    this.items = this.items.filter(item => !removeElements.includes(item.key));
    this.selectedAuthenticator.emit(auth);
  }

  onSearchChange() {
    this.filterAuthenticators();
  }

  onCheckboxChange(auth: any) {
    if (auth.selected) {
      // Add to selected items list if not already present
      if (!this.selectedItemsForDeletion.includes(auth.displayName)) {
        this.selectedItemsForDeletion.push(auth.displayName);
      }
    } else {
      // Remove from selected items list
      const index = this.selectedItemsForDeletion.indexOf(auth.displayName);
      if (index > -1) {
        this.selectedItemsForDeletion.splice(index, 1);
      }
    }
  }

  onSelectItem(item) {
    this.selectedItem.emit(item);
  }

  private showDeleteModal(selectedItemsForDeletion: any) {
    const modal = this._modalService.open(ModalConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
        data: { 
          titleModal: 'AUTHENTICATION.DELETE_AUTHENTICATORS', 
          messageModal: 'AUTHENTICATION.CONFIRM_DELETE', 
          messageButtonConfirmation: 'GLOBAL.DELETE',
          typeButton: 'success',
          colorHeader: 'neutral',
          messageButtonCancel: 'GLOBAL.CANCEL'
        }
    });
    modal.afterClosed().subscribe((result) => {
      if (result === 'confirm') {
        this.deleteAuthenticators.emit(this.selectedItemsForDeletion);
      }  else
        this.onCancelDelete();
    });
  }

  private filterAuthenticators() {
    if (!this.searchValue || this.searchValue.trim() === '') {
      // If search is empty, show all authenticators sorted by displayName
      this.filteredAuthenticatorList = [...this.authenticatorList].sort((a, b) => 
        a.displayName.localeCompare(b.displayName)
      );
    } else {
      // Filter by displayName (case-insensitive) and sort the results
      const searchTerm = this.searchValue.toLowerCase().trim();
      this.filteredAuthenticatorList = this.authenticatorList
        .filter(auth => 
          auth.displayName && auth.displayName.toLowerCase().includes(searchTerm)
        )
        .sort((a, b) => a.displayName.localeCompare(b.displayName));
    }
  }
}
